import React, {
  HTMLInputTypeAttribute,
  InputHTMLAttributes,
  useContext,
} from "react";
import {
  ContactFormContext,
  IFormData,
} from "../../context/ContactFormDataContext";
import useValidInputCtx from "../../hooks/useValidInputCtx";
import * as S from "./style";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: keyof IFormData["userInputs"];
  type: HTMLInputTypeAttribute;
}

function CustomInput(
  { type = "text", name, ...customParam }: InputProps) {
  const { formData } = useContext(ContactFormContext);
  const { inputParams: { onChange, onFocus, onBlur }, error } = useValidInputCtx(name);

  return (
    <>
      <S.Input
        className={error ? "input-error" : ""}
        type={type}
        name={name}
        onFocus={onFocus}
        onChange={onChange}
        onBlur={onBlur}
        value={formData.userInputs[name]}
        {...customParam}
      />
      {error && <span className="error-icon">!</span>}
    </>
  );
}

export default CustomInput;
